import React from "react";
import LGWashingPageTemplate from "./LGWashingPageTemplate";

const relatedLinks = [
  { to: "/lg-appliance-service-bangalore", label: "LG Appliance Service" },
  { to: "/lg-washing-machine-service-bangalore", label: "LG Washing Machine Service" },
  { to: "/lg-washing-machine-repair-bangalore", label: "LG Washing Machine Repair" },
  { to: "/lg-washing-machine-not-spinning", label: "LG Washing Machine Not Spinning" },
  { to: "/lg-front-load-washing-machine-service-bangalore", label: "LG Front Load Service" },
];

const LGTopLoadService = () => {
  return (
    <LGWashingPageTemplate
      title="LG Top Load Washing Machine Service in Bangalore"
      description="LG top load washing machine service in Bangalore for water inlet faults, spin issues, agitator problems, and regular maintenance."
      keywords="lg top load washing machine service bangalore, lg top load repair, lg washing machine service"
      path="/lg-top-load-washing-machine-service-bangalore"
      bannerTitle="LG Top Load Service in Bangalore"
      intro={<>Our <span style={{ fontWeight: 'bold' }}>LG top load washing machine service</span> team in Bangalore handles common problems such as poor agitation, water filling issues, drain faults, and spin performance complaints. We provide doorstep support for inspection and repair.</>}
      highlights={[
        "Water inlet, pump, and drain support",
        "Agitator and impeller problem diagnosis",
        "Timer and control panel inspection",
        "Routine service and maintenance visits",
      ]}
      issues={[
        "Water not filling correctly",
        "Agitator not moving",
        "Drainage and overflow issues",
        "Unbalanced spin and vibration",
      ]}
      relatedLinks={relatedLinks}
    />
  );
};

export default LGTopLoadService;
